export default __webpack_public_path__ + "static/media/voucher1.ea258b64.png";